import { Tooltip } from "antd";
import React, { Fragment } from "react";
// import thums from "../../../../styles/images/thumsup.png";
// import sticker1 from "../../../../styles/images/sticker1.webp";
// import sticker2 from "../../../../styles/images/sticker2.webp";
// import sticker3 from "../../../../styles/images/sticker3.webp";
// import sticker4 from "../../../../styles/images/sticker4.webp";
import styles from "./stickerMessage.module.scss";
import ChatLike from "../chatLike";
import ChatHoverOption from "../chatHoverOption";
import ChatUserInfo from "../chatUserInfo";
// import { StatusTag } from "../../../../shared/widgets/statusTag";
// import { URCheckBox } from "../../../../shared/widgets/checkbox";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import moment from "moment";
import { chats, initialStateModel } from "../../../../models/model";
import { useSelector } from "react-redux";
import store from "../../../../context/store/store";
import { Types } from "../../../../context/action/action";
import _ from "lodash";
import { URCheckBoxCall } from "../../../../shared/widgets/checkBoxForCall/callCheckBox";
type stickerMessageProps = {
  data: any;
  previewopen?: Function;
  multiData?: any;
  audioVideo?: any;
  savedData?: any;
  timeValue?: any;
}
export default function ChatStickerMessage({ data, multiData, audioVideo, savedData, timeValue }: stickerMessageProps) {

  let { id, direction, timestamp, fromcaller_details } = Array.isArray(data) && data?.length > 0 ? data[0] : "";
  let isReply = Array.isArray(data) && data?.length > 0 && data[0].message?.isReply ? true : false;
  let htimestamp = moment(timestamp).format('hh:mm A');
  let timeCount = timeValue !== undefined ? timeValue : 18;
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const handlehighlightHover = () => {
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.classList.add("highlighthover");
    }

  };
  const handleOnChange = (e: any,messageData:any) => {
    let deletedArray: any = chatReducer.selectMessageData;

    let index = [];
    if (e.target.checked) {
      let arr: any = [...deletedArray,messageData]
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: arr
        }
      });
    } else {
      // _.forEach(messageData, function (element: any) {
      //   index = deletedArray.indexOf(element);
      //   deletedArray.splice(index, 1);
      // });

    index = deletedArray.indexOf(messageData);
    deletedArray.splice(index, 1);
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: deletedArray
        }
      });
    }

  };
  return (
    <>
      {/* <div className={`${styles.chatMsg} ${styles.leftMessage} ${styles.addBookleftMessage}`}> */}
      {
        direction === 'IN' ? <div className={`lftMessage ${styles.chatMsg} ${styles.leftMessage} ${(chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ) ? "checked" : chatReducer?.multiOption? "checking" : ""}`} id={id}>
          {!isReply && timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
            <ChatUserInfo userDetails={fromcaller_details} className='userinfoIcon leftSide' />
            <div className={styles.convMemName}><span>{fromcaller_details?.caller_id}</span></div>
          </div>}
          <div className={styles.chatLeftMessages}>
            <div className={styles.chatLeft}>
              {!isReply && <Tooltip title={htimestamp} className='cusTooltip'
                overlayClassName='customTooltip'><div className={styles.chatTime}>{htimestamp}</div></Tooltip>}
              <div className={`${styles.chatContent}`}>

                <div className={styles.stickerContent}>
                  {data.map((msgList: any, index: any) => {
                    let messageBody = msgList?.message.body;
                    // console.log(msgList,'Inside File OUT Direction',msgList?.direction);
                    if (msgList?.direction === "IN") {
                      return (
                        <Fragment key={index}>
                          <span key={index} className={id === savedData ? "focusText" : styles.stickerArea} tabIndex={0}>
                            <img src={messageBody?.filePath} alt="" />
                            <div className={styles.stickerInfo}>
                              {Array.isArray(data) && data?.length > 0 && !isReply && <ChatLike className='likeRight stickerLike' placement="topRight"
                                tooltipTitle={msgList.likeduserdetails} message={msgList} />}
                            {!isReply &&  <div className={styles.stickerInfoleft}>{!isReply && <ChatLeftInfo userDetails={fromcaller_details}
                                timeStamp={timestamp} message={msgList}></ChatLeftInfo>}</div>}
                            </div>


                            {audioVideo &&  <div className={`chatInnerHoveroptn stickerMsg ${styles.hoverOptions}`}>
                              <ChatHoverOption className='hoverList hoverListleft' data={msgList} multiFile={data} highlightHover={handlehighlightHover} /></div>}
                              {!isReply &&(!chatReducer?.isDelete && chatReducer?.multiOption) && Array.isArray(data) && data?.length > 0 &&
                     <URCheckBoxCall
                      checked={chatReducer?.selectMessageData?.indexOf(msgList) > -1 ? true : false}
                      className={`chatSelectRight ${styles.sticker}`} onChange={(e:any)=>handleOnChange(e,msgList)} />}
                          </span>
                        </Fragment>)
                    } else {
                      return null;
                    }
                  })}
                </div>


              </div>
            </div>
          </div>


        </div>
          :
          <div className={`rtMessage ${styles.chatMsg} ${styles.rightMessage} ${(chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ) ? "checked" : chatReducer?.multiOption? "checking" : ""}`} id={id}>
            {!isReply && timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
              <div className={styles.convMemName}><span>You</span></div>
              <ChatUserInfo userDetails={fromcaller_details} className='userinfoIcon rightSide' />
            </div>}
            <div className={styles.chatRightMessages}>
              <div className={styles.chatRight}>
                <div className={`${styles.chatContent}`}>
                  <div className={styles.stickerContent}>
                    {data.map((msgList: any, index: any) => {
                      let messageBody = msgList?.message.body;
                      // console.log(msgList,'Inside File OUT Direction',msgList?.direction);
                      if (msgList?.direction === "OUT") {
                        return (
                          <Fragment key={index}>
                            <span key={index} className={id === savedData ? "focusText" : styles.stickerArea} tabIndex={0}>
                              <img src={messageBody?.filePath} alt="" />
                              <div className={styles.stickerInfo}>
                                {Array.isArray(data) && data?.length > 0 && !isReply && <ChatLike className='likeRight stickerLike' placement="topRight"
                                  tooltipTitle={msgList?.likeduserdetails} message={msgList} />}
                                {!isReply && <div className={styles.stickerInfoRight}>{!isReply && <ChatRightInfo userDetails={fromcaller_details}
                                  timeStamp={timestamp} message={msgList}></ChatRightInfo>}

                                </div>
                                }

                              </div>

                             {audioVideo &&  <div className={`chatInnerHoveroptn stickerMsg ${styles.hoverOptions}`}>
                                <ChatHoverOption className='hoverList hoverListright hoverSticker' data={msgList} multiFile={data} highlightHover={handlehighlightHover} /></div>
                              }
                              {!isReply &&(!chatReducer?.isDelete && chatReducer?.multiOption) && Array.isArray(data) && data?.length > 0 &&
              <URCheckBoxCall
                checked={chatReducer?.selectMessageData?.indexOf(msgList) > -1 ? true : false}
                className="chatSelectRight" onChange={(e:any)=>handleOnChange(e,msgList)} />}
                              {/*       */}
                            </span>

                          </Fragment>)
                      } else {
                        return null;
                      }
                    })}

                  </div>

                  {/* {Array.isArray(data) && data?.length > 0 && !isReply && <ChatLike className='likeRight' placement="topRight"
                    tooltipTitle={data[0]?.likeduserdetails} message={data[0]} />} */}
                </div>
                {!isReply && <Tooltip placement="topRight" title={htimestamp} className='cusTooltip'
                  overlayClassName='customTooltip'><div className={styles.chatTime}>{htimestamp}</div></Tooltip>}
              </div>
            </div>


          </div>
      }


    </>
  );
};

